
import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { errorGlobal, successGlobal } from '../reducers/notifications'
import { setTokenCookie ,setUserData,getUserData} from '../../utils/tools';
import { getAuthHeader, removeTokenCookie,removeUserData } from '../../utils/tools';




const BASE_URL="https://backend.nativehelper.com/news/api/auth/"

 //const BASE_URL="http://localhost:8080/api/auth/"

//const BASE_URL="http://192.168.1.5:8080/api/auth/"
//const BASE_URL1="http://localhost:8080/api/userinfo/"
const BASE_URL1="https://backend.nativehelper.com/news/userinfo/"



//const BASE_URL="http://103.117.180.14:8080/news/api/auth/"
//const [cookies, setCookie] = cookiessss(['name']);





export const registerUser = createAsyncThunk(
    'users/registerUser',
    async({name,email,password,phoneNo,pincode,place,distcId,talukId,regnlID},{dispatch})=>{
       // console.log(email)
       // console.log(password)
      

        const usersData = {

            
        name:name,
        username:email,
        email:email,
        password:password,
        phoneNo:phoneNo,
        designation:"USER",
        pincode:pincode,
        place:pincode,
        distcId:distcId,
        talukId:talukId,
        regnlID:regnlID
    };
    const  customConfig = {
    headers: {
    'Content-Type': 'application/json'
    }
};
        try{
            const request = await axios.post(`${BASE_URL}signup`,usersData,customConfig );
            //console.log(request.data.accessToken)
            //console.log(request.data.tokenType)
            //console.log(request.data.userId)
           // console.log(request.data)
            dispatch(successGlobal('Welcome !!.Check your emails to validate account'))
            console.log(request)
           
            return { data:request.data.user, auth:true }
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            
            throw error;
        }
    }
)

// const headers = {
//     'Content-Type': 'application/json',
//     'Authorization': 'JWT fefege...'
//   }
  
//   axios.post(Helper.getUserAPI(), data, {
//       headers: headers
//     })
//     .then((response) => {
//       dispatch({
//         type: FOUND_USER,
//         data: response.data[0]
//       })
//     })
//     .catch((error) => {
//       dispatch({
//         type: ERROR_FINDING_USER
//       })
//     })

export const signInUser = createAsyncThunk(
    'users/signInUser',
    async({email,password},{dispatch})=>{
        email=email
        password=password
        console.log(email)
        
        try{
            const request = await axios.post(`${BASE_URL}signin`,{
                usernameOrEmail: email,
                password:password
               
                
                
            },{
                headers: {
                    "Content-Type": "application/json"
                  }
            });
           
            setTokenCookie(request.data.accessToken);
            let usersData={
                userId:"",
                userName:"",
                roleId:"",
                role:""
            }
            usersData.userId=request.data.userId;
            usersData.userName=request.data.username;
            usersData.roleId=request.data.roles[0].id;
            usersData.role=request.data.roles[0].name;
           setUserData(usersData);
           
            



           
          


           // request.cookie('x-access-token',request.data.accessToken)
           //console.log(request.data.tokenType)
           dispatch(successGlobal('Welcome !!'))
          

            return { data:request.data, auth:true }
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error;
        }
    }
)

// export const isAuth = createAsyncThunk(
//     'users/isAuth',
//     async()=>{
//         try{
//             const request = await axios.get('/api/auth/isauth',getAuthHeader())
//             return { data:request.data, auth:true }

//         } catch(error){
        
//             return { data:{},auth:false}
//         }
//     }
// )

export const isAuth = createAsyncThunk(
    'users/isAuth',
    async()=>{
        
         
            if((!getAuthHeader()!=null && !getAuthHeader().headers.Authorization.valueOf()!='Bearer') )
            {
                return { data:getUserData(), auth:true }
            }
            else{
                return { data:{},auth:false}
            }
           }

        
    
)
export const signOut = createAsyncThunk(
    'users/signOut',
    async()=>{
        
        removeUserData()
        removeTokenCookie();
        
    }
)

//GETTING  CURENT USER DETAILS 
export const getuserDetails = createAsyncThunk(
    'users/getuserDetails',
    async(dispatch)=>{
          try{
            const request = await axios.get(`${BASE_URL}user/${getUserData().userId}`,getAuthHeader());

            //return request.data;
            //{ data:request.data.user, auth:true }
            return { data:request.data.user };
            
             } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
             }
    }
)


//UPDATING USER DETAILS 
export const updateUserProfile = createAsyncThunk(
    'users/updateUserProfile',
    async(user,{ dispatch })=>{

      
        const user1 = {
            id:getUserData().userId,
            name:user.name,
            place:user.place,
             pincode:user.pincode,
             userName:getUserData().userName,
             districtID:user.districtID,
             talukID:user.talukID
            
        };

       
    try{

           

           // console.log(newsData.heading)
          
         //   console.log("888888888888888888888");
           
            const request = await axios.post(`${BASE_URL}userUpdate`,user1,getAuthHeader());
            dispatch(successGlobal('User update !!'))
           
            return request.data;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
           //createAsyncThunkonsole.log("1000000000000000000");
            console.log(error.response.data);
            //console.log("333333333333333333333");
            throw error
        }
    }

    
)


export const changeEmail = createAsyncThunk(
    'users/changeEmail',
    async(data,{dispatch})=>{
    
        try{
            const request = await axios.post(`${BASE_URL}usereml`,{
                id:getUserData().userId,
                email:data.newemail
            },getAuthHeader());
            dispatch(successGlobal('Email updated !!'))

           
            return {

                email: request.data.user.email,
                verified:false
            }
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
           throw error; 
        }
    }
)

export const changePhNO = createAsyncThunk(
    'users/changePhNO',
    async(data,{dispatch})=>{
        console.log("*****************************")
            console.log(data.newephoneNo)
         
            console.log("*****************************")
    
        try{
            const request = await axios.post(`${BASE_URL}userphno`,{
                id:getUserData().userId,
                phoneNo:data.newephoneNo
            },getAuthHeader());
            dispatch(successGlobal(request.data.message))

            // console.log("*****************************")
            // console.log(request.data.message)
            // console.log(request.data.user.phoneNo)
            // console.log(request)
            // console.log("*****************************")
            return {

                phoneNo: request.data.user.phoneNo,
                verified:false
            }
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
           throw error; 
        }
    }
)


//UPDATING USER DETAILS 
export const updateUserPsw = createAsyncThunk(
    'users/updateUserPsw',
    async(user,{ dispatch })=>{

        
       
        const user1 = {
            usernameOrEmail:user.oldpassword,
            password:user.newpassword1
            
        };

       
    try{

           

           // console.log(newsData.heading)
          
         //   console.log("888888888888888888888");
           
            const request = await axios.post(`${BASE_URL1}change-password/${getUserData().userId}`,user1,getAuthHeader());
            
            return request.data;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
           //createAsyncThunkonsole.log("1000000000000000000");
            console.log(error.response.data);
            //console.log("333333333333333333333");
            throw error
        }
    }

    
)
